<div class="flex flex-col gap-1">
  <label class="text-sm font-medium text-slate-700 flex items-center gap-2">
    <i class="bi bi-printer text-blue-600"></i>
    Impresora
  </label>

  @if (loading()) {
    <div class="p-4 bg-slate-50 rounded-lg border border-slate-200 flex items-center gap-3">
      <i class="bi bi-arrow-repeat text-blue-600 text-lg animate-spin"></i>
      <span class="text-sm text-slate-600">Cargando impresoras...</span>
    </div>
  } @else if (conError()) {
    <div class="p-4 bg-red-50 rounded-lg border border-red-200 flex items-center gap-3">
      <i class="bi bi-exclamation-circle text-red-600 text-lg"></i>
      <span class="text-sm text-red-700">Error cargando impresoras</span>
    </div>
  } @else {
    <app-select
      [(ngModel)]="impresora"
      (onChange)="onChange($event)"
      [options]="opcionesImpresoraComputed()"
      optionLabel="label"
      optionValue="value"
      [filter]="opcionesImpresora().length > 10"
      placeholder="Selecciona una impresora..."
      [showClear]="impresora() !== null"
      class="w-full"
      appendTo="body"
    />
  }
</div>
